import { Container } from '@mui/material';
import { ResourceDetail } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ResourceDetailView = () => {
  const { resourceId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <ResourceDetail id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
